"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const v_calendar_1 = require("v-calendar");
const moment_1 = __importDefault(require("moment"));
let ModalEditionReports = class ModalEditionReports extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.stateLoader = true;
        this.stateSave = true;
        this.sampleName = '';
        this.attributes = [
            {
                key: 'today',
                dates: new Date(),
                highlight: {
                    backgroundColor: '#ff8080',
                    // Other properties are available too, like `height` & `borderRadius`
                },
            },
        ];
        this.themeStyles = [
            {
                background: '#111',
            },
        ];
        this.dateValue = '';
        this.masks = {
            input: 'YYYY-MM-DD',
        };
        this.day = '';
    }
    dateTime(val) {
        let dates = (0, moment_1.default)(val).format('YYYY-MM-DD');
        return dates;
    }
    Time() {
        setTimeout(() => {
            this.stateLoader = false;
        }, 1500);
    }
    saved() {
        return (this.item.sample = 'Hola');
    }
    created() {
        this.Time();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ModalEditionReports.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ModalEditionReports.prototype, "locale", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ModalEditionReports.prototype, "cropActived", void 0);
ModalEditionReports = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Calendar: v_calendar_1.Calendar,
            DatePicker: v_calendar_1.DatePicker,
        },
    })
], ModalEditionReports);
exports.default = ModalEditionReports;
